/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionRead } from '../models/ActionRead';
import type { ControlRead } from '../models/ControlRead';
import type { PaginatedResponse_RiskRead_ } from '../models/PaginatedResponse_RiskRead_';
import type { RiskCreate } from '../models/RiskCreate';
import type { RiskDetail } from '../models/RiskDetail';
import type { RiskHistory } from '../models/RiskHistory';
import type { RiskRead } from '../models/RiskRead';
import type { RiskReviewRequest } from '../models/RiskReviewRequest';
import type { RiskTreeNode } from '../models/RiskTreeNode';
import type { RiskUpdate } from '../models/RiskUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RisksService {
    /**
     * Create Risk Endpoint
     * @returns RiskRead Successful Response
     * @throws ApiError
     */
    public static createRiskEndpointRisksPost({
        requestBody,
    }: {
        requestBody: RiskCreate,
    }): CancelablePromise<RiskRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/risks/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Risks
     * @returns PaginatedResponse_RiskRead_ Successful Response
     * @throws ApiError
     */
    public static listRisksRisksGet({
        owner,
        category,
        status,
        riskType,
        includeArchived = false,
        overdueReview,
        appetiteBreach,
        overdueTreatment,
        treatmentStatus,
        limit = 20,
        offset,
        sort,
        q,
    }: {
        owner?: (string | null),
        category?: (string | null),
        status?: (string | null),
        riskType?: (string | null),
        includeArchived?: boolean,
        overdueReview?: (boolean | null),
        appetiteBreach?: (boolean | null),
        overdueTreatment?: (boolean | null),
        treatmentStatus?: (string | null),
        limit?: number,
        offset?: number,
        sort?: (string | null),
        q?: (string | null),
    }): CancelablePromise<PaginatedResponse_RiskRead_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/',
            query: {
                'owner': owner,
                'category': category,
                'status': status,
                'risk_type': riskType,
                'include_archived': includeArchived,
                'overdue_review': overdueReview,
                'appetite_breach': appetiteBreach,
                'overdue_treatment': overdueTreatment,
                'treatment_status': treatmentStatus,
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Risk Tree
     * @returns RiskTreeNode Successful Response
     * @throws ApiError
     */
    public static getRiskTreeRisksTreeGet({
        includeArchived = false,
    }: {
        includeArchived?: boolean,
    }): CancelablePromise<Array<RiskTreeNode>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/tree',
            query: {
                'include_archived': includeArchived,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Search Risks
     * @returns RiskRead Successful Response
     * @throws ApiError
     */
    public static searchRisksRisksSearchGet({
        query = '',
        includeArchived = false,
    }: {
        query?: string,
        includeArchived?: boolean,
    }): CancelablePromise<Array<RiskRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/search',
            query: {
                'query': query,
                'include_archived': includeArchived,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Risk Endpoint
     * @returns RiskDetail Successful Response
     * @throws ApiError
     */
    public static getRiskEndpointRisksRiskIdGet({
        riskId,
        includeActions = false,
        includeControls = false,
    }: {
        riskId: number,
        includeActions?: boolean,
        includeControls?: boolean,
    }): CancelablePromise<RiskDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/{risk_id}',
            path: {
                'risk_id': riskId,
            },
            query: {
                'include_actions': includeActions,
                'include_controls': includeControls,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Risk Endpoint
     * @returns RiskRead Successful Response
     * @throws ApiError
     */
    public static updateRiskEndpointRisksRiskIdPut({
        riskId,
        requestBody,
    }: {
        riskId: number,
        requestBody: RiskUpdate,
    }): CancelablePromise<RiskRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/risks/{risk_id}',
            path: {
                'risk_id': riskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Risk
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteRiskRisksRiskIdDelete({
        riskId,
        confirmationText,
        hard = false,
        reason,
    }: {
        riskId: number,
        confirmationText?: (string | null),
        hard?: boolean,
        reason?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/risks/{risk_id}',
            path: {
                'risk_id': riskId,
            },
            query: {
                'confirmation_text': confirmationText,
                'hard': hard,
                'reason': reason,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Risk Endpoint
     * @returns RiskRead Successful Response
     * @throws ApiError
     */
    public static reviewRiskEndpointRisksRiskIdReviewPost({
        riskId,
        requestBody,
    }: {
        riskId: number,
        requestBody: RiskReviewRequest,
    }): CancelablePromise<RiskRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/risks/{risk_id}/review',
            path: {
                'risk_id': riskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Restore Risk Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static restoreRiskEndpointRisksRiskIdRestorePost({
        riskId,
        reason,
    }: {
        riskId: number,
        reason?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/risks/{risk_id}/restore',
            path: {
                'risk_id': riskId,
            },
            query: {
                'reason': reason,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Controls For Risk
     * @returns ControlRead Successful Response
     * @throws ApiError
     */
    public static listControlsForRiskRisksRiskIdControlsGet({
        riskId,
    }: {
        riskId: number,
    }): CancelablePromise<Array<ControlRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/{risk_id}/controls',
            path: {
                'risk_id': riskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Actions For Risk
     * @returns ActionRead Successful Response
     * @throws ApiError
     */
    public static listActionsForRiskRisksRiskIdActionsGet({
        riskId,
    }: {
        riskId: number,
    }): CancelablePromise<Array<ActionRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/{risk_id}/actions',
            path: {
                'risk_id': riskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Risk History
     * @returns RiskHistory Successful Response
     * @throws ApiError
     */
    public static getRiskHistoryRisksRiskIdHistoryGet({
        riskId,
    }: {
        riskId: number,
    }): CancelablePromise<Array<RiskHistory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/risks/{risk_id}/history',
            path: {
                'risk_id': riskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
